module.exports = __webpack_public_path__ + "static/what-if-344219336445c7cdee9e3d2ca3f00a8d.jpg";